// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._18m915vq{overflow-y:hidden}
._1bah1h6o{justify-content:center}
._1bsb1osq{width:100%}
._1e0c1txw{display:flex}
._1reo15vq{overflow-x:hidden}
._4cvr1h6o{align-items:center}
._4t3i1osq{height:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/emoji/dist/esm/components/compiled/common/EmojiFallback.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,sBAAsB;AACjC,WAAW,UAAU;AACrB,WAAW,YAAY;AACvB,WAAW,iBAAiB;AAC5B,WAAW,kBAAkB;AAC7B,WAAW,WAAW","sourcesContent":["._18m915vq{overflow-y:hidden}\n._1bah1h6o{justify-content:center}\n._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._1reo15vq{overflow-x:hidden}\n._4cvr1h6o{align-items:center}\n._4t3i1osq{height:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
